import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "market-header-details-mobile" }
const _hoisted_2 = { class: "market-header-details-mobile__item" }
const _hoisted_3 = { class: "market-header-details-mobile__label" }
const _hoisted_4 = { class: "market-header-details-mobile__item" }
const _hoisted_5 = { class: "market-header-details-mobile__label" }
const _hoisted_6 = { class: "market-header-details-mobile__item" }
const _hoisted_7 = { class: "market-header-details-mobile__label" }
const _hoisted_8 = { class: "market-header-details-mobile__item" }
const _hoisted_9 = { class: "market-header-details-mobile__label-group" }
const _hoisted_10 = { class: "market-header-details-mobile__label" }
const _hoisted_11 = {
  key: 1,
  class: "market-header-details-mobile__item"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "market-header-details-mobile__label" }, "Funding / Countdown", -1)
const _hoisted_13 = {
  key: 0,
  class: "market-header-details-mobile__value-group"
}
const _hoisted_14 = { class: "market-header-details-mobile__countdown" }
const _hoisted_15 = {
  key: 1,
  class: "market-header-details-mobile__value"
}

import { useIntervalFn } from '@vueuse/core';
import type { PropType } from 'vue';
import { computed, ref, watch } from 'vue';
import { VTooltip, VIcon } from 'vuetify/components';

import BigNumber from '@exchange/helpers/bignumber';
import { useFundingRate } from '@exchange/libs/funding-rate/service/src';
import type { FundingRateData } from '@exchange/libs/funding-rate/service/src/lib/funding-rate-model.js';
import type { MarketModel } from '@exchange/libs/market/service/src';
import { MarketType } from '@exchange/libs/market/service/src/lib/market-model';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';
import type { CurrencyModel } from '@exchange/libs/utils/currency/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketHeaderDetailsMobile',
  props: {
  currencies: { type: Object as PropType<Dictionary<CurrencyModel>>, required: false },
  defaultFiatCurrency: { type: String, required: true },
  market: { type: Object as PropType<MarketModel>, required: true },
},
  setup(__props) {

const props = __props;

const fiatVolume = computed(() => {
  const currencyFiatValue = props.currencies?.[CONSTANTS.DEFAULT_FOR_CURRENCY_FORMATTING]?.defaultFiatValue;

  if (currencyFiatValue === undefined) {
    return Number.NaN;
  }

  return new BigNumber(props.market.allDay.globalVolume).times(currencyFiatValue);
});

const quoteCode = computed(() => props.market.quote.code);
const marketPrecision = computed(() => props.market.marketPrecision);
const dayHigh = computed(() => props.market.allDay.high);
const dayLow = computed(() => props.market.allDay.low);
const lastPrice = computed(() => props.market.lastPrice);

const zeroPrecision = CONSTANTS.PRECISION.ZERO;

const fundingRateData = ref<FundingRateData | null>(null);
const { fundingRate, isLoading: isFundingRateLoading } = useFundingRate(computed(() => props.market?.id || ''));

watch(
  [fundingRate, () => props.market?.type],
  ([newVal, marketType]) => {
    if (marketType === MarketType.PERP && newVal) {
      fundingRateData.value = newVal;
    }
  },
  { immediate: true },
);

const getNextFundingTime = () => {
  const now = new Date();
  now.setMinutes(0, 0, 0);
  const currentHour = now.getUTCHours();
  const nextInterval = Math.ceil((currentHour + 1) / 4) * 4;
  const next = new Date(now);
  next.setUTCHours(nextInterval, 0, 0, 0);
  if (next <= now) {
    next.setTime(next.getTime() + 4 * 60 * 60 * 1000);
  }
  return next;
};

const nextFundingTime = ref(getNextFundingTime());
const countdown = ref('');

const updateCountdown = () => {
  const now = new Date();
  const diff = nextFundingTime.value.getTime() - now.getTime();

  if (diff <= 0) {
    nextFundingTime.value = getNextFundingTime();
    updateCountdown();
    return;
  }

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  countdown.value = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

useIntervalFn(updateCountdown, 1000);

const isFutures = computed(() => props.market?.type === MarketType.PERP);

return (_ctx: any,_cache: any) => {
  const _component_ot_number_display = _resolveComponent("ot-number-display")!
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('modules.marketDetails.currentPrice')), 1),
      _createVNode(_component_ot_number_display, {
        class: "market-header-details-mobile__value",
        grouping: true,
        "left-aligned": true,
        number: lastPrice.value,
        precision: marketPrecision.value,
        "smaller-suffix": true,
        suffix: quoteCode.value
      }, null, 8, ["number", "precision", "suffix"])
    ]),
    (!isFutures.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('modules.marketDetails.24hHigh')), 1),
            _createVNode(_component_ot_number_display, {
              class: "market-header-details-mobile__value",
              grouping: true,
              "left-aligned": true,
              number: dayHigh.value,
              precision: marketPrecision.value,
              "smaller-suffix": true,
              suffix: quoteCode.value
            }, null, 8, ["number", "precision", "suffix"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('modules.marketDetails.24hLow')), 1),
            _createVNode(_component_ot_number_display, {
              class: "market-header-details-mobile__value",
              grouping: true,
              "left-aligned": true,
              number: dayLow.value,
              precision: marketPrecision.value,
              "smaller-suffix": true,
              suffix: quoteCode.value
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('modules.marketDetails.24hVolume')), 1),
        _createVNode(_unref(VTooltip), {
          text: _ctx.$t('modules.marketDetails.globalVolumeTooltip'),
          location: "bottom"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_ot_icon, _mergeProps(props, {
              class: "market-header-details-mobile__info-icon",
              name: "info-circle"
            }), null, 16)
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      _createVNode(_component_ot_number_display, {
        class: "market-header-details-mobile__value",
        grouping: true,
        "left-aligned": true,
        number: fiatVolume.value,
        precision: _unref(zeroPrecision),
        "smaller-suffix": true,
        suffix: __props.defaultFiatCurrency
      }, null, 8, ["number", "precision", "suffix"])
    ]),
    (isFutures.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          (!_unref(isFundingRateLoading) && fundingRateData.value && countdown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_ot_number_display, {
                  class: "market-header-details-mobile__value",
                  "add-plus-sign": false,
                  "colored-percentage": true,
                  "left-aligned": true,
                  number: Number(fundingRateData.value.funding_rate) * 100,
                  percentage: true,
                  precision: 4
                }, null, 8, ["number"]),
                _createElementVNode("span", _hoisted_14, _toDisplayString(countdown.value), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('fundamentals.emptyValues.default')), 1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})